
import { NoticeProps} from "@/scripts/datatypes"
import { GroupData, PostStatus } from "../../common-datatypes"
import { Component,Mixins} from "vue-property-decorator";
import { ValidationObserver,ValidationProvider } from 'vee-validate'
import Common from '@/mixins/common'
import TemplateMembers from '@/components/TemplateMembers.vue';
import ModalSelectUser from '@/components/ModalSelectUser.vue';
import { ValidationFlags } from "vee-validate/dist/types/types";


@Component({
  components: {
    ModalSelectUser,
    TemplateMembers
  }
})


export default class AddGroup extends Mixins(Common) {
  notice = {} as NoticeProps
  disabledAddGroup = true
  defaultGroupData: GroupData = {
    hostUserIds: [],
    guestUserIds: [],
    name: '',
    description: '',
    memberUserIds: [],
    postStatus: 'draft',
    disabled: false,
    deleted: false,
    memberMeta: {}
  }
  tIsShow = false
  sIsShow = false
  theGroup = {...this.defaultGroupData}
  isLoading = false

  $refs!: {
    hosts: InstanceType<typeof ValidationProvider>;
    guests: InstanceType<typeof ValidationProvider>;
    validationObserver: InstanceType<typeof ValidationObserver>;
  }

  postStatuses(){
    if(this.$te('event.postStatus')){
      return this.$t('event.postStatus') as unknown as PostStatus
    }
    return undefined
  }

  get memberUserIds(){
    return Array.from(new Set([...this.theGroup.hostUserIds,...this.theGroup.guestUserIds]))
  }

  async addGroup(){
		try{
			this.notice = {
				isShow: false,
			}
		
      if(await this.$refs.validationObserver.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        
        const data: GroupData = {
          ...this.theGroup,
          memberUserIds: this.memberUserIds
        }

        // eslint-disable-next-line
        const GroupDocRef = await this.$createDoc(this.$getGroupsColRef(),data)
        
        this.notice = {
          message: this.$t('addGroup.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }
        
        this.theGroup = {...this.defaultGroupData}

        this.$nextTick(() =>{
          this.$refs.validationObserver.reset()
        })
      }
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('addGroup.error') as string
      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
			
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }

  mounted(){
   console.log('mounted')
   this.$watch('$refs.validationObserver.flags',(flags: ValidationFlags) => {
    this.disabledAddGroup = ! flags.changed
   })
  }

  created(){
    console.trace('created')
  }
 
  destroyed() {
    console.trace('destroyed');
  }

}
